import React, { useEffect, useState } from "react";
import InputLeftIcon from "../components/form_item/InputLeftIcon";
import { Icon } from "@iconify/react";
import { Card, Form, Button } from "react-bootstrap";
import logoslogin from "../assets/logoslogin.png";
import { useStore } from "../store/useStore";
import { login } from "../services/auth.service";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { get_staff } from "../services/staff.service";
import PopUpNotiLogin5req from "../components/popup/PopUpNotiLogin5req";
import { filter } from "lodash";

export default function LoginPage() {
  const navigate = useNavigate();
  // state
  const [isLoading, setIsLoading] = useState(true);
  const [countLogin, setCountLogin] = useState(0);
  const [popup, setPopup] = useState();
  const [disabled, setDisabled] = useState();
  const [statusLogin, setStatusLogin] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [validate, setValidate] = useState({
    username: false,
    password: false,
  });
  // store
  const { setProfile,  setToken, getBranchData } = useStore();
  //useEffect

  // function
  const getDataProfile = async (staffId, token) => {
    try {
      setIsLoading(true);
      const data = await get_staff(staffId, token);
      if (data?.error) throw new Error(data?.message);
      let staff = data?.data;

      setProfile(staff);
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const checkValidate = () => {
    let _validate = {};
    let state = false;
    if (!username) {
      _validate.username = true;
      state = true;
    }
    if (!password) {
      _validate.password = true;
      state = true;
    }
    setValidate(_validate);
    return state;
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setDisabled({ buttonLogin: true });
      setStatusLogin("");
      setCountLogin((prev) => prev + 1);

      const stateCheck = checkValidate();
      if (stateCheck) throw new Error("validate");

      const _body = {
        userName: username,
        password: password,
      };
      const data = await login(_body);

      if (data?.error) {
        setStatusLogin(data?.message);
        throw new Error(data?.message);
      }
      
      if (data?.accessToken) {
        setToken(data?.accessToken);
        const decoded = jwtDecode(data?.accessToken);
        console.log("decoded", decoded);
        await getDataProfile(decoded?.id, data?.accessToken);
        await getBranchData(data?.accessToken);
        setCountLogin(0);
        navigate("/dashboard");
      } else {
        setStatusLogin("token is empty");
        throw new Error("token is empty");
      }

      setDisabled();
    } catch (err) {
      console.error(err);
      setDisabled();
    }
    if (countLogin >= 5) {
      setPopup({ PopUpNotiLogin5req: true });
    }
  };
  return (
    <div
      className="login-bg"
      style={{      
        // backgroundColor: "#BBDEFB",  
        padding: 10,
        height: "100dvh",
        minHeight: "100dvh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
       
      }}
    >
      <Card
        style={{
          padding: "40px 40px",
          // maxWidth: 500,
          width: "500px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
         
        }}
      >
        <div style={{ width: "40%" }}>
          <img src={logoslogin} alt="" style={{ width: "100%" }} />
        </div>
        <div style={{ marginBottom: 20, textAlign: "center" }}>
          <h1 style={{ fontSize: 20, fontWeight: 700 }}>ເຂົ້າສູ່ລະບົບ</h1>
          {/* <p style={{ fontSize: 16, color: "gray"}}>ກະລຸນາປ້ອນໄອດີຜູ້ໃຊ້ ແລະ ລະຫັດຜ່ານ</p> */}
        </div>
        <Form onSubmit={handleLogin} style={{width: "450px"}}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div>
              <label style={{ fontSize: 16 }}>ໄອດີຜູ້ໃຊ້</label>
              <InputLeftIcon
              stye={{width: "100%"}}
                icon={
                  <Icon
                    icon="ant-design:user-outlined"
                    style={{ width: 24, height: 24 }}
                  />
                }
                value={username}
                isInvalid={validate?.username}
                onChange={(e) => {
                  // var lowercase = e.target.value?.toLowerCase();
                  var lowercase = e.target.value;
                  setUsername(lowercase);
                }}
                placeholder="ປ້ອນໄອດີຜູ້ໃຊ້"
              />
            </div>
            <div>
              <label style={{ fontSize: 16 }}>ລະຫັດຜ່ານ</label>
              <InputLeftIcon

                type="password"
                icon={
                  <Icon icon="uil:lock" style={{ width: 24, height: 24 }} />
                }
                eye="true"
                value={password}
                isInvalid={validate?.password}
                // isValid={false}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="ປ້ອນລະຫັດຜ່ານ"
              />
            </div>
            <div
              style={{
                display: statusLogin ? "flex" : "none",
                color: "#FF0000",
                gap: 5,
                alignItems: "center",
              }}
            >
              <Icon
                icon="material-symbols:info-outline"
                style={{ width: 18, height: 18 }}
              />
              <span>
                {statusLogin ? "ໄອດີຜູ້ໃຊ້ ຫຼື ລະຫັດຜ່ານບໍ່ຖືກຕ້ອງ" : ""}
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
              <Button
                size="lg"
                style={{ minWidth: 450, fontSize: 18, fontWeight: "bold" }}
                onClick={handleLogin}
                disabled={disabled?.buttonLogin}
                type="submit"
              >
                ເຂົ້າສູ່ລະບົບ
              </Button>
            </div>
          </div>
        </Form>
      </Card>
      {/* popup */}
      <PopUpNotiLogin5req
        open={popup?.PopUpNotiLogin5req}
        onClose={() => setPopup()}
      />
    </div>
  );
}
